<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Declaraties</h1>
        </div>
        <div class="controls">
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    <div>
        <div class="pb-3">
            Gebruik de VVR app voor het invoeren van je declaraties.
        </div>
        <div class="row">
            <div class="col-auto">
                <button color="primary" mat-raised-button routerLink="/{{Routenames.declarationRequest}}/new">
                    Declaratie indienen
                </button>
            </div>
            @if (showStatusFilter()) {
                <div class="col-auto">
                    <mat-form-field class="status-filter">
                        <mat-select (selectionChange)="getData()" [(ngModel)]="statusIds" multiple placeholder="Status filter">
                            @for (status of statusList(); track status) {
                                <mat-option [value]="status.id">{{status.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            }
            @if ('declarationManagement' | hasFeature) {
                <div class="col-auto">
                    <button
                        class="ms-5"
                        color="primary"
                        mat-raised-button
                        routerLink="/{{Routenames.declarationReport}}">
                        Rapportage
                    </button>
                </div>
            }
        </div>
        <div class="pt-3">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th (click)="sortList('id')" matRipple>
                            #
                            <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" property="id"></app-sorting-icon>
                        </th>
                        <th>
                            Declaratie
                        </th>
                        <th>
                            Bedrag
                        </th>
                        <th>
                            Status
                        </th>
                        <th class="d-none d-md-table-cell">
                            Aangemaakt door
                        </th>
                        <th (click)="sortList('created_at')" class="d-none d-md-table-cell" matRipple>
                            Aangemaakt
                            <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" property="created_at"></app-sorting-icon>
                        </th>
                        <th class="trash-column">

                        </th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of list(); track item) {
                        <tr class="curpoint" routerLink="/{{Routenames.declarationRequest}}/{{item.id}}">
                            <td>
                                {{item.id}}
                            </td>
                            <td>
                                {{item.type.name}}
                            </td>
                            <td>
                                {{item.amount | currency : 'EUR'}}
                            </td>
                            <td>
                                {{item.status.name}}
                            </td>
                            <td class="d-none d-md-table-cell">
                                {{item?.user?.name}}
                            </td>
                            <td class="d-none d-md-table-cell">
                                {{item.created_at | date : 'd MMM yyyy, H:mm'}}
                            </td>
                            <td class="pt-0 pb-0">
                                @if (item.user_id === user()?.id && item.status_id === 1) {
                                    <button
                                        (click)="delete($event, item)"
                                        color="warn"
                                        mat-icon-button>
                                        <i class="fa fa-trash"></i>
                                    </button>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
